import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Wand2, Trash2, FileText } from "lucide-react";

const KEYS = ["legal_name", "uei", "cage", "tin", "address", "phone", "email", "signer_name",
  "signer_title", "amount", "solicitation", "title", "date", "signature"];

export default function LearnedMapsTab() {
  const [data, setData] = useState({ forms: [], total: 0 });
  const load = () => api.get("/library/learned-maps").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const edit = async (fingerprint, label, key) => {
    try { await api.put("/library/learned-maps", { fingerprint, label, key }); toast.success("Updated"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const revoke = async (fingerprint, label) => {
    if (!window.confirm(`Revoke the learned mapping for "${label}"?`)) return;
    try { await api.delete(`/library/learned-maps?fingerprint=${encodeURIComponent(fingerprint)}&label=${encodeURIComponent(label)}`); toast.success("Revoked"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div data-testid="learned-maps-tab">
      <p className="text-sm text-zinc-500 mb-4">
        Field→key mappings your team has taught the form engine, per government form. These auto-fill the same
        form on every future bid. Scoped to your organization; admins can edit or revoke. ({data.total} total)
      </p>
      {data.forms.length === 0 && (
        <div className="text-xs text-zinc-400 py-10 text-center border border-dashed border-zinc-300 rounded-xl">
          No learned mappings yet. When someone corrects a flagged form field on a bid, it will appear here.
        </div>
      )}
      <div className="space-y-4">
        {data.forms.map((f) => (
          <div key={f.fingerprint} data-testid={`learned-form-${f.fingerprint}`} className="bg-white border border-zinc-200 shadow-sm rounded-xl">
            <div className="px-4 py-3 border-b border-zinc-200 flex items-center gap-2">
              <FileText className="h-4 w-4 text-zinc-400" />
              <span className="text-sm font-semibold text-zinc-900">{f.form_title || "Unknown form"}</span>
              <span className="text-[10px] font-mono text-zinc-400">{f.fingerprint}</span>
            </div>
            <div className="divide-y divide-zinc-100">
              {f.maps.map((m) => (
                <div key={m.norm_label} data-testid={`learned-map-${m.norm_label}`} className="px-4 py-2.5 flex items-center gap-3 text-sm">
                  <Wand2 className="h-3.5 w-3.5 text-gold-dark shrink-0" />
                  <span className="text-zinc-800 flex-1 truncate">{m.label}</span>
                  <span className="text-zinc-400 text-xs">→</span>
                  <select value={m.key} data-testid={`learned-key-${m.norm_label}`} onChange={(e) => edit(f.fingerprint, m.label, e.target.value)}
                    className="text-xs border border-zinc-300 rounded px-1.5 py-1 bg-white">
                    {KEYS.map((k) => <option key={k} value={k}>{k}</option>)}
                  </select>
                  <span className="text-[10px] text-zinc-400 hidden sm:inline">by {m.by}</span>
                  <button data-testid={`revoke-map-${m.norm_label}`} onClick={() => revoke(f.fingerprint, m.label)} className="p-1.5 rounded hover:bg-zinc-100 text-red-500"><Trash2 className="h-3.5 w-3.5" /></button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
